import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import {
  PhishingSign,
  PhishingSignsListResponse,
  SavePhishingSignRequest,
} from './types';

export const phishingSignsService = (client: AxiosInstance) => {
  const PHISHING_SIGNS_BASE_URL = '/gophish/phishing-signs';

  const getPhishingSigns = async (): Promise<PhishingSignsListResponse> => {
    try {
      const result = await client.get<
        PhishingSignsListResponse,
        AxiosResponse<PhishingSignsListResponse>
      >(PHISHING_SIGNS_BASE_URL, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getPhishingSign = async (id: string): Promise<PhishingSign> => {
    try {
      const result = await client.get<
        PhishingSign,
        AxiosResponse<PhishingSign>
      >(`${PHISHING_SIGNS_BASE_URL}/${id}`, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const createPhishingSign = async (
    request: SavePhishingSignRequest,
  ): Promise<PhishingSign> => {
    try {
      const result = await client.post<
        PhishingSign,
        AxiosResponse<PhishingSign>
      >(PHISHING_SIGNS_BASE_URL, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const updatePhishingSign = async (
    id: string,
    request: SavePhishingSignRequest,
  ): Promise<PhishingSign> => {
    try {
      const result = await client.patch<
        PhishingSign,
        AxiosResponse<PhishingSign>
      >(`${PHISHING_SIGNS_BASE_URL}/${id}`, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const deletePhishingSign = async (id: string): Promise<void> => {
    try {
      await client.delete(`${PHISHING_SIGNS_BASE_URL}/${id}`, {
        withCredentials: true,
      });
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getPhishingSigns,
    getPhishingSign,
    createPhishingSign,
    updatePhishingSign,
    deletePhishingSign,
  };
};
